/**
 * Navbar
 */

const navbar = (container) => {
  let header = container.querySelector('.header');

  window.addEventListener('scroll', requestTick, false);

  // Get the offset position of the navbar
  let pinOffset = header.offsetHeight;

  // keep track of previous scroll position
  let prevScrollPos = window.scrollY;

  // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
  let update = () => {
    let currentScrollPos = window.scrollY;
    if (window.scrollY > pinOffset) {
      if (prevScrollPos > currentScrollPos) {
        // user has scrolled up
        header.classList.add('pin');
        header.classList.remove('out');
      } else {
        // user has scrolled down
        header.classList.add('out');
        header.classList.remove('pin');        
      }
    } else {
      header.classList.remove("pin");
      header.classList.remove("out");
    }

    // update previous scroll position
    prevScrollPos = currentScrollPos;
  }

  function requestTick() {
    requestAnimationFrame(update);
  }

}

export {navbar};
